import classnames from 'classnames'
import { Popup } from 'semantic-ui-react'

import styles from './index.css'

import type { FC, ReactNode } from 'react'
import type { PopupProps } from 'semantic-ui-react'

export type TooltipProps = {
  tooltip: ReactNode
} & Omit<PopupProps, 'content'>

const Tooltip: FC<TooltipProps> = ({
  children,
  className = '',
  hideOnScroll = true,
  hoverable = true,
  on = ['hover', 'click', 'focus'],
  position = 'top center',
  size = 'small',
  tooltip,
  ...props
}) => (
  <Popup
    {...props}
    className={classnames(styles.tooltip, className)}
    content={tooltip}
    hideOnScroll={hideOnScroll}
    hoverable={hoverable}
    on={on}
    position={position}
    size={size}
    trigger={children}
  />
)

export default Tooltip
